<template>
    <div class="footer">
        <ul class="section-1 content">
            <li>
                <a class="phone" :href="`tel:${info.tel}`">{{ info.tel }}</a>
                <p class="phone-content">{{ info.tel_text }}</p>
            </li>
            <li>
                <p>{{ info.consult }}</p>
                <a :href="`mailto:${info.consult_email}`">{{ info.consult_email }}</a>
            </li>
            <li>
                <p>{{ info.join }}</p>
                <a :href="`mailto:${info.join_email}`">{{ info.join_email }}</a>
            </li>
            <li class="qr-code">
                <img :src="baseUrl + info.qrcode_img_upload" alt="二维码" />
                <div>
                    <p class="point">{{ info.qrcode_title }}</p>
                    <p>{{ info.qrcode_text }}</p>
                </div>
            </li>
        </ul>
        <div class="section-2 content">
            <a href="javascript:void(0)" @click="$router.push({ name: 'homePage' })"><img :src="baseUrl + info.logo_footer_img_upload" alt="logo" /></a>
            <ul>
                <li @click="navigateToItenm(0)">首页</li>
                <li>|</li>
                <li @click="navigateToItenm(1)">解决方案</li>
                <li>|</li>
                <li @click="navigateToItenm(2)">产品展示</li>
                <li>|</li>
                <li @click="navigateToItenm(3)">经典案例</li>
                <li>|</li>
                <li @click="navigateToItenm(4)">新闻中心</li>
                <li>|</li>
                <li @click="navigateToItenm(5)">关于我们</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeTab: 0,
        }
    },
    props: {
        info: {
            type: Object,
            default: () => {},
        },
        activePage: {
            type: [String, Number],
            default: 0,
        },
    },
    methods: {
        navigateToItenm(n) {
            this.showMenu = false
            this.$emit("update:activePage", Number(n))
            switch (n) {
                case 0:
                    this.$router.push({ name: "homePage" })
                    break
                case 1:
                    this.$router.push({ name: "schemePage" })
                    break
                case 2:
                    this.$router.push({ name: "productPage" })
                    break
                case 3:
                    this.$router.push({ name: "casePage" })
                    break
                case 4:
                    this.$router.push({ name: "newsCenter" })
                    break
                case 5:
                    this.$router.push({ name: "aboutPage" })
                    break
            }
            window.sessionStorage.setItem("nav", n)
        },
    },
}
</script>

<style lang="scss" scoped>
.footer {
    padding: 0.44rem 0 0.8rem 0;
    background-color: #26263d;
    p,
    a,
    li,
    ul {
        font-size: 0.18rem;
        color: #fff;
        text-decoration: none;
    }
    .section-1,
    .section-2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .section-1 {
        li {
            font-size: 0.16rem;
            a {
                display: inline-block;
            }
            p {
                margin-bottom: 0.24rem;
            }
            &:first-of-type {
                p {
                    margin: 0;
                }
            }
        }
        img {
            margin-right: 0.2rem;
            width: 0.68rem;
            height: 0.68rem;
            object-fit: contain;
            background-color: #eee;
        }
        .qr-code {
            display: flex;
            align-items: flex-start;
            p {
                font-size: 0.12rem;
                margin-bottom: 0.12rem;
            }
            .point {
                font-size: 0.14rem;
                color: #50d43f;
            }
        }

        .phone {
            margin-bottom: 0.24rem;
            font-size: 0.28rem;
            font-weight: bold;
        }
    }
    .section-2 {
        justify-content: flex-start;
        margin-top: 0.68rem;
        img {
            margin-right: 1.1rem;
            width: 1.7rem;
            object-fit: cover;
        }
        ul {
            display: flex;
            align-items: center;
            li {
                margin-left: 0.25rem;
                cursor: pointer;
            }
        }
    }
}
@media screen and (max-width: 425px) {
    .footer {
        display: flex;
        flex-direction: column-reverse;
        .section-1 {
            flex-direction: column-reverse;
            li {
                display: flex;
                align-items: center;
                margin: 0.2rem 0;
                text-align: center;
                p {
                    margin: 0;
                }
                &:first-of-type {
                    flex-direction: row-reverse;
                }
                & > p,
                & > a {
                    font-size: 0.68rem;
                    margin: 0 0.25rem !important;
                }
            }
            .phone {
                margin: 0;
                font-size: 0.68rem;
            }
            .qr-code {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 1rem 0;
                img {
                    width: 4rem;
                    height: 4rem;
                }
                p,
                .point {
                    display: none;
                    font-size: 0.68rem;
                }
            }
            img {
                margin: 0;
            }
        }
        .section-2 {
            display: flex;
            flex-direction: column-reverse;
            width: 100%;
            img {
                width: 5rem !important;
                margin: 1.2rem 0 !important;
                margin-bottom: 0.6rem !important;
            }
            ul {
                li {
                    font-size: 0.6rem;
                    word-break: keep-all;
                    &:first-of-type {
                        margin: 0;
                    }
                }
            }
        }
    }
}
</style>
